import type { ChangelogApi } from '@ipen-portal/plugin-changelog-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const changelogApiRef = createApiRef<
  TRPCOptionsProxy<ChangelogApi>
>().with({
  id: 'plugin.ipen.changelog.api',
});
